import { Component, Input, OnInit } from '@angular/core';
import { ResearchInfrastructure } from '../../../model/research-infrastructure';
import { ResearchInfrastructureOrganisation } from '../../../model/research-infrastructure-classes';


@Component({
    selector: 'res-infrastructure-view-main-data',
    templateUrl: './research-infrastructure-view-main-data.component.html',
})
export class ResearchInfrastructureViewMainDataComponent {

    @Input() researchInfrastructure: ResearchInfrastructure = new ResearchInfrastructure();
    @Input() operators: ResearchInfrastructureOrganisation[];
    @Input() coordinators: ResearchInfrastructureOrganisation[];

    public getOperatorsAsString(): string {
        /* get all containing Operators */
        let operatorsStr = '';
        if (this.operators) {
            for (let op of this.operators){
                if(op.researchPartner){
                    operatorsStr +=  op.researchPartner.defaulttext;
                }
                else if (op.orgunit) {
                    operatorsStr +=  op.orgunit.text;
                }
                operatorsStr +=  ', ';
            }
            operatorsStr = operatorsStr.substring(0,operatorsStr.length-2);
        }
        return operatorsStr;
    }

    public getCoordinatorsAsString(): string {
        /* get all containing Coordinators */
        let coordinatorsStr = '';
        if (this.coordinators) {
            for (let co of this.coordinators){
                if(co.orgunit){
                    coordinatorsStr +=  co.orgunit.text;
                }
                else if (co.researchPartner) {
                    coordinatorsStr +=  co.researchPartner.defaulttext;
                }
                coordinatorsStr +=  ', ';
            }
            coordinatorsStr = coordinatorsStr.substring(0,coordinatorsStr.length-2);
        }
        return coordinatorsStr;
    }

}
